import * as React from "react";
import {ReactElement} from "react";
import {Button} from "@mui/material";
import ArrowBackRoundedIcon from "@mui/icons-material/ArrowBackRounded";
import {RootState} from "../../redux/store";
import {connect} from "react-redux";
import {ILanguageTokens} from "../../localization/LanguageTokens";
import {useNavigate} from "react-router-dom";

interface IProps {
    languageTokens: ILanguageTokens;
}

function BackButton({languageTokens}: IProps): ReactElement {
    const navigate = useNavigate();

    const handleGoBack = () => {
        navigate(-1);
    };

    return <Button
        aria-label="Back"
        variant={'contained'}
        sx={{width: 40}}
        onClick={handleGoBack}
    >
        <ArrowBackRoundedIcon/>
    </Button>
}

const mapStateToProps = (state: RootState) => ({
    languageTokens: state.language.languageTokens,
});

const mapActionsToProps = {
};

export default connect(mapStateToProps, mapActionsToProps)(BackButton);

